import LikeActionTypes from '../types/likes';

const LikeActions = { types: LikeActionTypes }

const likesRequest = (method, likeable, likeableType, action, callback) => {
  return Q($.ajax({
    url: `/likes?likeable_id=${likeable.id}&likeable_type=${likeableType}`,
    type: method
  })).then(response => {
    callback(action(likeable, response));
  });
}

LikeActions.create = (likeable, response) => {
  const increment = !!response.created;

  return ({
    type: LikeActions.types.CREATE,
    likeable,
    increment
  });
}

LikeActions.destroy = (likeable, response) => {
  const decrement = !!response.destroyed;

  return ({
    type: LikeActions.types.DESTROY,
    likeable,
    decrement
  });
}

LikeActions.createForLikeable = (likeable, likeableType, callback) => {
  return likesRequest('POST', likeable, likeableType, LikeActions.create, callback);
}

LikeActions.destroyForLikeable = (likeable, likeableType, callback) => {
  return likesRequest('DELETE', likeable, likeableType, LikeActions.destroy, callback);
}

LikeActions.fetchUsers = (likeable, likeableType) => {
  return Q($.ajax({
    url: `/likes?likeable_id=${likeable.id}&likeable_type=${likeableType}`,
    type: 'GET'
  }));
}

export default LikeActions;
